import './styles.css';
import React, { Component } from 'react';
import Card from '../../../CardNew';
import GeneralRibbonUtils from '../../GeneralRibbonUtils';
import { MOREPOPULAR } from '../../constants';
import store from '../../../../store';
import { setFromData } from '../../../../actions/navbar';

class RibbonPopular extends Component {
    constructor(props) {
        super(props);
        this.carruselTitle = props.carruselTitle;
        this.items = props.items;
        this.visibleItems = props.visibleItems;
        this.badgesUserType = props.badgesUserType;
        this.ignoreSeenLast = props.ignoreSeenLast;
        this.focusSettings = props.focusSettings;
        this.ribbonId = props.ribbonId;
        this.focusHandler = props.focusHandler;
        this.onClickHandler = props.onClickHandler;
        this.setMetricsEvent = props.setMetricsEvent;
        this.hideInnerTitle = props.hideInnerTitle;
        this.keyDownHandler = props.keyDownHandler;
        this.className = props.className;
        this.title = props.title;
        this.ribbonIndex = props.index;
        this.dataUpdateMetrics = props.dataUpdateMetrics;
        this.ribbonName = props.ribbonName;
        this.idsRibbonsUpAndDown = props.idsRibbonsUpAndDown;
    }

    render() {
        return (
            <div className="ribbon-items ribbon-popular">
                {this.visibleItems.map((node, index) => {
                    const node_item = node.item;
                    const badges = GeneralRibbonUtils.getBadgesHTML(this.badgesUserType, node_item);
                    const key = `${this.ribbonId}-${node_item.group_id || node_item.id}-pos-${index}`;
                    let uri = null;
                    const dataMetricsRibbon = {
                        node_item,
                        node_location: location.pathname,
                        ribbon_title: this.props.carruselTitle || this.ribbonId,
                    };

                    if (this.props.type === 'user-profile') {
                        if (node && node_item && node_item.typeContent) {
                            uri = node_item.src;
                        } else {
                            uri = `/socialProfile/${node_item.id}`;
                        }
                    } else {
                        uri = node_item.src;
                    }
                    return (
                        <Card
                            unFocusHandler={this.unFocusHandler}
                            id={index + 1}
                            ribbonId={this.ribbonId}
                            key={key}
                            ribbonIndex={this.ribbonIndex}
                            ignoreSeenLast={this.ignoreSeenLast}
                            data={node_item}
                            group_id={node_item.group_id || node_item.id}
                            portrait={node_item.portrait}
                            hideTitles={this.props.hideTitles}
                            label={node_item.label}
                            type={MOREPOPULAR}
                            title={node_item.title}
                            badges={badges}
                            dataMetric={{
                                carruselTitle: this.carruselTitle,
                                cardPosition: GeneralRibbonUtils.getPosition(
                                    this.items,
                                    node_item.title
                                ),
                            }}
                            focusable={true}
                            focusRight={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusLeft={`#${this.ribbonId} ${this.focusSettings.selector}`}
                            focusHandler={this.focusHandler}
                            setMetricsEvent={this.setMetricsEvent}
                            onClick={(e) => {
                                this.dataUpdateMetrics(dataMetricsRibbon)
                                if (node_item && (node_item.type === 'live' || node_item.filterTV)) {
                                    this.onClickHandler(node_item);
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }
                            }
                            clickHandler={node_item.clickHandler || this.onClickHandler}
                            sibling={node_item.sibling}
                            href={uri}
                            hideInnerTitle={this.hideInnerTitle}
                            bookmark={node_item.bookmark ? String(node_item.bookmark) : '0'}
                            keyDownHandler={this.keyDownHandler}
                            filterTV={node_item.filterTV ? node_item.filterTV : null}
                            ribbonName={this.ribbonName}
                            ribbonLength= {this.visibleItems.length}
                            idsRibbonsUpAndDown={this.idsRibbonsUpAndDown}
                        />
                    );
                })}
            </div>
        );
    }
}

export default RibbonPopular;



// WEBPACK FOOTER //
// ./src/components/RibbonNew/RibbonTypes/RibbonPopular/index.jsx